module.exports = __webpack_public_path__ + "img/srcmNum4.2f17c72e.png";